module.exports = __webpack_public_path__ + "static/media/logo-no-text-inverted.20e1470c.png";